/* Size gate: the add-to-cart button stays locked until the customer picks a size themselves.
   Works with the Swatch King app (variant-swatch-king) and the native variant-selects underneath,
   on the product page, in the quick-add popup and on the sticky add-to-cart bar. */
(() => {
  if (window.lookstanSizeGate) return;
  const ar = (document.documentElement.lang || '').toLowerCase().startsWith('ar');
  const T = ar
    ? { button: 'اختار مقاسك الأول', hint: 'اختار المقاس عشان تكمّل', sticky: 'اختار المقاس' }
    : { button: 'Select your size', hint: 'Please select your size first', sticky: 'Select size' };
  const SIZE = /size|مقاس|حجم/i;

  const sizeGroups = (root) => {
    const groups = [];
    root.querySelectorAll('variant-swatch-king [option-name]').forEach((el) => {
      if (SIZE.test(el.getAttribute('option-name')) && el.querySelectorAll('li.swatch-view-item').length > 1) groups.push(el);
    });
    root.querySelectorAll('variant-selects fieldset').forEach((el) => {
      if (SIZE.test(el.querySelector('legend')?.textContent || '') && el.querySelectorAll('input[type=radio]').length > 1) groups.push(el);
    });
    root.querySelectorAll('variant-selects .product-form__input--dropdown').forEach((el) => {
      if (SIZE.test(el.querySelector('label')?.textContent || '') && el.querySelectorAll('option').length > 1) groups.push(el);
    });
    return groups;
  };
  const visibleGroup = (root) => sizeGroups(root).find((g) => g.offsetParent !== null) || sizeGroups(root)[0];
  const addButton = (root) => root.querySelector('button[name="add"]');
  const isMain = (root) => !root.closest('quick-add-modal, .quick-add-modal');
  const locked = (root) => root.dataset.lsSizeLock === '1';

  const stripSelection = (root) => {
    sizeGroups(root).forEach((g) => {
      g.classList.add('ls-size-group');
      g.querySelectorAll('.swatch-selected').forEach((el) => el.classList.remove('swatch-selected'));
      g.querySelectorAll('li[aria-checked="true"]').forEach((li) => li.setAttribute('aria-checked', 'false'));
    });
  };

  const setLabel = (root, on) => {
    const button = addButton(root);
    if (!button) return;
    const label = button.querySelector('[data-premium-atc-label]') || button.querySelector('span');
    if (on) {
      button.classList.add('ls-size-locked');
      button.setAttribute('aria-describedby', 'ls-size-hint');
      if (label && label.dataset.lsOriginal === undefined) label.dataset.lsOriginal = label.textContent;
      if (label && label.textContent !== T.button) label.textContent = T.button;
    } else {
      button.classList.remove('ls-size-locked');
      button.removeAttribute('aria-describedby');
      if (label && label.dataset.lsOriginal !== undefined) {
        if (label.textContent === T.button) label.textContent = label.dataset.lsOriginal;
        delete label.dataset.lsOriginal;
      }
    }
  };

  const setSticky = (on) => {
    const sticky = document.querySelector('sticky-add-to-cart');
    if (!sticky) return;
    sticky.classList.toggle('ls-size-locked', on);
    if (!sticky._lsWatch) {
      sticky._lsWatch = new MutationObserver(() => {
        if (sticky.classList.contains('ls-size-locked')) setSticky(true);
      });
      sticky._lsWatch.observe(sticky, { childList: true, characterData: true, subtree: true });
    }
    const details = sticky.querySelector('.sticky-atc__mobile-details');
    const option = [...sticky.querySelectorAll('.sticky-atc__variant-option')].find((el) => SIZE.test(el.textContent));
    const button = sticky.querySelector('.sticky-atc__button span');
    [[details, T.sticky], [option?.querySelector('strong'), '—'], [button, T.sticky]].forEach(([el, text]) => {
      if (!el) return;
      if (on) {
        if (el.textContent !== text) {
          el.dataset.lsOriginal = el.textContent;
          el.textContent = text;
        }
      } else if (el.dataset.lsOriginal !== undefined) {
        if (el.textContent === text) el.textContent = el.dataset.lsOriginal;
        delete el.dataset.lsOriginal;
      }
    });
  };

  const lock = (root) => {
    root.dataset.lsSizeLock = '1';
    stripSelection(root);
    setLabel(root, true);
    if (isMain(root)) setSticky(true);
  };

  const unlock = (root) => {
    if (!locked(root)) return;
    root.dataset.lsSizeLock = '0';
    setLabel(root, false);
    if (isMain(root)) setSticky(false);
    root.querySelectorAll('.ls-size-hint').forEach((el) => el.remove());
    root.querySelectorAll('.ls-size-attention').forEach((el) => el.classList.remove('ls-size-attention'));
  };

  const init = (root) => {
    if (root.dataset.lsSizeLock) {
      if (locked(root)) { stripSelection(root); setLabel(root, true); }
      return;
    }
    const button = addButton(root);
    if (!button || button.disabled) return; // nothing to buy (sold out) – leave as is
    if (!sizeGroups(root).length) return; // one-size product or the app has not rendered yet
    lock(root);
  };

  const scan = () => document.querySelectorAll('product-info').forEach(init);

  const remind = (root) => {
    const group = visibleGroup(root);
    if (!group) return;
    group.classList.remove('ls-size-attention');
    void group.offsetWidth;
    group.classList.add('ls-size-attention');
    if (!root.querySelector('.ls-size-hint')) {
      const hint = document.createElement('p');
      hint.className = 'ls-size-hint';
      hint.id = 'ls-size-hint';
      hint.setAttribute('role', 'alert');
      hint.textContent = T.hint;
      group.after(hint);
    }
    const top = group.getBoundingClientRect().top;
    if (top < 80 || top > window.innerHeight - 160) {
      const scroller = root.closest('.quick-add-modal__content-info, quick-add-modal .quick-add-modal__content') || null;
      group.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (scroller) scroller.scrollTop = Math.max(0, group.offsetTop - 120);
    }
  };

  // The customer picked a size -> unlock.
  const onPick = (event) => {
    if (!event.isTrusted) return;
    const root = event.target.closest('product-info');
    if (!root || !locked(root)) return;
    const group = sizeGroups(root).find((g) => g.contains(event.target));
    if (!group) return;
    const item = event.target.closest('li.swatch-view-item, input, label, select');
    if (!item) return;
    unlock(root);
    // Re-picking the size that was pre-selected fires no change in the app: restore its highlight.
    const li = event.target.closest('li.swatch-view-item');
    if (li) {
      setTimeout(() => {
        if (!group.querySelector('.swatch-selected')) {
          li.setAttribute('aria-checked', 'true');
          li.querySelector('.swatch-selector')?.classList.add('swatch-selected');
        }
      }, 60);
    }
  };
  document.addEventListener('click', onPick, true);
  document.addEventListener('change', onPick, true);

  // Block add-to-cart while locked.
  const guard = (event) => {
    const target = event.target;
    let root = null;
    if (event.type === 'submit') {
      const form = target;
      root = form.closest('product-info') || document.querySelector(`product-info [form="${form.id}"]`)?.closest('product-info');
    } else {
      const button = target.closest('button[name="add"], .sticky-atc__button');
      if (!button) return;
      root = button.closest('product-info') || [...document.querySelectorAll('product-info')].find(isMain);
    }
    if (!root || !locked(root)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    remind(root);
  };
  document.addEventListener('click', guard, true);
  document.addEventListener('submit', guard, true);

  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; scan(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  window.lookstanSizeGate = { scan, unlock };
})();
